export type Shadows = typeof shadows;

export const shadows = {
  xs: '0,0,0,rgba(0,0,0,1)',
  s: '0,0,0,rgba(0,0,0,1)',
  m: '0,0,0,rgba(0,0,0,1)',
  l: '0,0,0,rgba(0,0,0,1)',
} as const;
